import { render, staticRenderFns } from "./nuevaPass.vue?vue&type=template&id=453773fe&scoped=true&"
import script from "./nuevaPass.vue?vue&type=script&lang=js&"
export * from "./nuevaPass.vue?vue&type=script&lang=js&"
import style0 from "./nuevaPass.vue?vue&type=style&index=0&id=453773fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453773fe",
  null
  
)

export default component.exports